const patternRut = "^((([0-9]{1,8}))(([0-9]{1,1})|(k{1,1})|(K{1,1})))$";
const RegexRut= new RegExp(patternRut);

function isValidRut(rut) {
    if (!RegexRut.test(rut) ) {
        return false;
    }

    const bodyPart = rut.slice(0, rut.length - 1);
    let digitPart = rut.slice(rut.length - 1);
    if (digitPart == "K") {
        digitPart = "k";
    }
    return calculateRutDigit(bodyPart) == digitPart;
}

function calculateRutDigit(rut) {
    let M=0;
    let S=1;

    for(;rut;rut=Math.floor(rut/10))
        S=(S + rut%10 *(9-M++%6))%11;

    return S ? S-1: 'k';
}

function formatRut(rut) {
    if (! RegexRut.test(rut)) {
        return "";
    }

    if (rut.length < 2) {
        return rut;
    }

    const bodyPart = rut.slice(0, rut.length - 1);
    let digitPart = rut.slice(rut.length - 1);
    if (digitPart == "k") {
        digitPart = "K";
    }

    const preFormatNumber = new Intl.NumberFormat().format(bodyPart)
    const formatedNumber = preFormatNumber.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')

    return `${formatedNumber}-${digitPart}`;
}

function formatRutAndDigit(bodyPart, digitPart) {
    const completeRut = bodyPart + digitPart;
    if (! RegexRut.test(completeRut)) {
        return "";
    }

    const preFormatNumber = new Intl.NumberFormat().format(bodyPart)
    const formatedNumber = preFormatNumber.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')

    return `${formatedNumber}-${digitPart}`;
}

exports.isValidRut = (rut) => {
    return isValidRut(rut);
};

exports.formatRut = (rut) => {
    return formatRut(rut);
};

exports.formatRutAndDigit = (bodyPart, digitPart) => {
    return formatRutAndDigit(bodyPart, digitPart);
};